import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthModule } from '@features/auth/auth.module';
import { ClientStateGuard } from '@features/client-state/client-state-guard';
import { ErrorModule } from '@features/error/error.module';
import { ErrorPageComponent } from '@features/error/error/error-page.component';
import { TermsOfUseComponent } from '@features/terms-of-use/terms-of-use.component';
import { DefaultLayoutComponent } from './app-layout/default-layout.component';
import { AuthGuardService } from './features/auth/auth-guard.service';
import { UserInfoComponent } from './features/auth/user-info/user-info.component';
import { NotfoundComponent } from './features/shared/notfound/notfound.component';
import { TermsOfUseGuard } from './features/terms-of-use/terms-of-use-guard';
import { TermsOfUseModule } from './features/terms-of-use/terms-of-use.module';

const routes: Routes = [
  {
    path: 'content-packages',
    canActivate: [AuthGuardService, TermsOfUseGuard, ClientStateGuard],
    loadChildren: () => import('app/features/content-packages/content-packages.module').then(
      (m) => m.ContentPackagesModule,
    ),
  },
  {
    path: 'terms-of-use',
    component: TermsOfUseComponent,
    canActivate: [AuthGuardService, ClientStateGuard],
  },
  {
    path: 'error',
    component: ErrorPageComponent,
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    canActivate: [AuthGuardService, TermsOfUseGuard, ClientStateGuard],
    children: [
      {
        path: 'search',
        loadChildren: () => import('app/features/search/search.module').then((module) => module.SearchModule),
      },
      {
        path: 'collections',
        loadChildren: () => import('app/features/collections/collection.module').then(
          (module) => module.CollectionModule,
        ),
      },
      {
        path: 'profile',
        loadChildren: () => import('app/features/profile/profile.module').then((module) => module.ProfileModule),
      },
      {
        path: 'user',
        component: UserInfoComponent,
      },
      {
        path: 'external-users',
        loadChildren: () => import('app/features/external-user/external-user.module').then(
          (module) => module.ExternalUserModule,
        ),
      },
      {
        path: '',
        loadChildren: () => import('app/features/home/home.module').then((module) => module.HomeModule),
      },
      { path: '**', component: NotfoundComponent },
    ],
  },
];

@NgModule({
  imports: [
    AuthModule,
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'top',
    }),
    TermsOfUseModule,
    ErrorModule,
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
